import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, Text, NumberInput, DateInput, Services, BubbleSelectBlock, Checkbox, Theme, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

class FinalizeClaimDetailsModal extends PureComponent {
    state = {
        // eslint-disable-next-line radix
        amountSubmitted: this.props.meta && !isNaN(parseInt(this.props.meta.amountSubmitted)) ? `${ Number(this.props.meta.amountSubmitted).toFixed(2) }` : '',
        serviceDate: (this.props.meta && this.props.meta.serviceDate) ? Services.dates.formatIncomingDate(this.props.meta.serviceDate) : null,
        paramedicalVisitType: this.props.meta && this.props.meta.paramedicalVisitType ? this.props.meta.paramedicalVisitType : '',
        paramedicalVisitLength: this.props.meta && this.props.meta.paramedicalVisitLength ? this.props.meta.paramedicalVisitLength : '',
        acceptedTerms: false,
        acceptedTermsError: false
    };

    componentDidMount() {
        this._saveData();
    }

    _handleInputChange = async (type, value) => {

        await this.setState({
            [type]: value
        });

        this._saveData();
    };

    _handleTermsChange = () => {
        this.setState({
            acceptedTerms: !this.state.acceptedTerms
        });
    };

    _saveData = () => {
        const data = {
            ...this.props.meta,
            // amountSubmitted: parseFloat(this.state.amountSubmitted.replace('$', '').replace(/,/g, "")),
            amountSubmitted: this.state.amountSubmitted,
            serviceDate: this.state.serviceDate,
            paramedicalVisitType: this.state.paramedicalVisitType,
            paramedicalVisitLength: this.state.paramedicalVisitLength
        };

        this.props.saveData(data, 'meta');
    };

    _next = async () => {
        const amountSubmittedError = await Services.validateInput('checkEmpty', this.state.amountSubmitted);
        const acceptedTermsError = !this.state.acceptedTerms ? i18n.t(tokens.labels.banking.youMustAcceptTermsError) : false;
        const serviceDateError = await Services.validateInput('date', this.state.serviceDate, i18n.locale);

        if (this.props.type === 'HealthSpending') {
            this.setState({
                amountSubmittedError,
                serviceDateError,
                acceptedTermsError
            });

            if (
                amountSubmittedError ||
                serviceDateError ||
                acceptedTermsError
            ) {
                return null;
            }

            this.props.next();
            return null;
        }

        let paramedicalVisitTypeError = null;

        if (localizationMaps.toEnglish("categories", this.props.meta.category).toUpperCase() === 'PARAMEDICALS') {
            paramedicalVisitTypeError = await Services.validateInput('checkEmpty', this.state.paramedicalVisitType);
        }

        this.setState({
            amountSubmittedError,
            serviceDateError,
            paramedicalVisitTypeError,
            acceptedTermsError
        });

        if (
            amountSubmittedError ||
            serviceDateError ||
            paramedicalVisitTypeError ||
            acceptedTermsError
        ) {
            return null;
        }

        this.props.next();
        return null;
    };

    render() {
        const { type } = this.props;

        return (
            <Modal
                testid="submit-receipt-modal"
                aria-labelledby="Submit receipt"
                open={true}
                onClose={ this.props.onClose }
                title={this.props.title}
                onBack={ this.props.onBack }
                loader={ this.props.loader }
                primaryButton={{
                    label: i18n.t(tokens.buttons.next),
                    onClick: this._next
                }}
            >
                <Text
                    medium
                    light
                    margin="10px 0"
                >
                    { i18n.t(tokens.labels.claims.reviewClaimDetails) }
                </Text>

                <NumberInput
                    prefix="$"
                    label={ i18n.t(tokens.labels.claims.amountSubmitted) }
                    value={ this.state.amountSubmitted }
                    onChange={(e) => this._handleInputChange('amountSubmitted', e.target.value)}
                    error={Boolean(this.state.amountSubmittedError)}
                    helperText={this.state.amountSubmittedError}
                    fullWidth
                    required
                    testid="amountsubmitted"
                    variant={"outlined"}
                />

                <DateInput
                    label={ i18n.t(tokens.labels.claims.serviceDate) }
                    value={ this.state.serviceDate || ''}
                    onChange={(e) => this._handleInputChange('serviceDate', e.target.value)}
                    error={Boolean(this.state.serviceDateError)}
                    helperText={this.state.serviceDateError}
                    fullWidth
                    required
                    testid="dateinput"
                    variant={"outlined"}
                />

                {
                    (type !== 'Health Spending' && localizationMaps.toEnglish("categories", this.props.meta.category).toUpperCase() === 'PARAMEDICALS') &&
                            <FormControl error={ true }>
                                <Text small bold margin="20px 0 0 0">{ i18n.t(tokens.labels.claims.typeOfVisit) }</Text>

                                <BubbleSelectBlock
                                    first={{
                                        title: i18n.t(tokens.buttons.subsequent),
                                        selected: this.state.paramedicalVisitType === 'subsequent',
                                        field: 'subsequent',
                                        customStyle: { minWidth: "160px" }
                                    }}
                                    second={{
                                        title: i18n.t(tokens.buttons.initial),
                                        selected: this.state.paramedicalVisitType === 'initial',
                                        field: 'initial',
                                        customStyle: { minWidth: "160px" }
                                    }}
                                    handleChange={ (field) => this._handleInputChange('paramedicalVisitType', field)}
                                />

                                <Text small bold margin="20px 0 0 0">{ i18n.t(tokens.labels.claims.serviceOver60Mins) }</Text>

                                <BubbleSelectBlock
                                    first={{
                                        title: i18n.t(tokens.buttons.yes),
                                        selected: this.state.paramedicalVisitLength === 'overSixty',
                                        field: 'overSixty',
                                        customStyle: { minWidth: "160px" }
                                    }}
                                    second={{
                                        title: i18n.t(tokens.buttons.no),
                                        selected: this.state.paramedicalVisitLength === 'sixtyAndUnder',
                                        field: 'sixtyAndUnder',
                                        customStyle: { minWidth: "160px" }
                                    }}
                                    handleChange={ (field) => this._handleInputChange('paramedicalVisitLength', field)}
                                />

                                {
                                    this.state.paramedicalVisitTypeError &&
                                        <FormHelperText style={{ fontFamily: Theme.fonts.type.base }}>{ this.state.paramedicalVisitTypeError }</FormHelperText>
                                }
                            </FormControl>
                }

                <FormControl error={ true }>
                    <FormGroup row style={{ marginTop: 20 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={ this.state.acceptedTerms }
                                    onChange={ this._handleTermsChange }
                                    value="acceptedTerms"
                                    testid="submitclaimcheckbox"
                                    color="secondary"
                                />
                            }
                            label={<Text avMedium>{ i18n.t(tokens.labels.claims.acknowledgeCorrectInfo) }</Text>}
                        />

                        {
                            this.state.acceptedTermsError &&
                                    <FormHelperText style={{ fontFamily: Theme.fonts.type.base }}>{ this.state.acceptedTermsError }</FormHelperText>
                        }
                    </FormGroup>
                </FormControl>

                <Text light tiny margin="20px 0 0 0">
                    { i18n.t(tokens.labels.claims.claimAgreementScreen2) }
                </Text>
            </Modal>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    user: state.user.meta,
    claimTypes: state.usage.data.claimTypes
});

export default connect(mapStateToProps)(FinalizeClaimDetailsModal);